var map = {
	"./Info.png": 6479,
	"./Info_new.png": 7636,
	"./addDC.png": 9157,
	"./addDC_new.png": 1398,
	"./arrow_right.png": 43,
	"./arrow_right_new.png": 3024,
	"./calSchls.png": 1942,
	"./costEstimate.png": 3758,
	"./cs.png": 6785,
	"./dashboardLogo.png": 3898,
	"./dashboardUser.png": 5062,
	"./dashboardUser_new.png": 169,
	"./dbSubscription.png": 1702,
	"./dbSubscription_new.png": 2425,
	"./dcExport.png": 7226,
	"./dcExport_new.png": 4877,
	"./deleteDC.png": 2677,
	"./deleteDC_new.png": 5478,
	"./disInfo.png": 7099,
	"./disInfo_new.png": 9408,
	"./discard.png": 6965,
	"./discard_new.png": 9862,
	"./download pdf.png": 41,
	"./downloadpdf.png": 6433,
	"./downloadpdf_new.png": 8178,
	"./dr.png": 8613,
	"./dr_new.png": 630,
	"./dsck.svg": 9582,
	"./dsckH.svg": 1018,
	"./dsuck.svg": 2115,
	"./dsuckH.svg": 2673,
	"./editDC.png": 6368,
	"./editDC_new.png": 535,
	"./editUser.png": 6222,
	"./editUser1.png": 485,
	"./enrollmentExport.png": 9897,
	"./enrollmentExport_new.png": 9114,
	"./error_under_maintenance.webp": 7572,
	"./es.png": 9047,
	"./es_old.png": 7149,
	"./greenCheck.svg": 2976,
	"./header12.png": 5829,
	"./heaer11.png": 830,
	"./hs.png": 8264,
	"./hs_old.png": 422,
	"./impNote.png": 8165,
	"./impNote_new.png": 22,
	"./mailSend.png": 4240,
	"./mailSend_new.png": 7703,
	"./menuHeader.png": 8265,
	"./menuHeader_new.png": 8954,
	"./ms.png": 1135,
	"./ms_old.png": 517,
	"./orderReport.png": 5037,
	"./orderReport_new.png": 6190,
	"./ps.png": 6544,
	"./ps_old.png": 5518,
	"./save_close.png": 994,
	"./save_close_new.png": 4694,
	"./schl.png": 7509,
	"./sck.png": 3062,
	"./sck.svg": 1044,
	"./sckH.svg": 6708,
	"./ss.png": 1985,
	"./ss_old.png": 8367,
	"./suck.svg": 4469,
	"./suckH.svg": 6503,
	"./surveyCheck.png": 4801,
	"./surveyCheck_new.png": 5410,
	"./surveyExport.png": 4807,
	"./surveyExport_new.png": 5724,
	"./surveyModule/es.png": 1518,
	"./surveyModule/es_old.png": 7596,
	"./surveyModule/hs.png": 2098,
	"./surveyModule/hs_old.png": 7843,
	"./surveyModule/ms.png": 7702,
	"./surveyModule/ms_old.png": 1972,
	"./surveyModule/ps.png": 717,
	"./surveyModule/ps_old.png": 1371,
	"./surveyModule/ss.png": 5215,
	"./surveyModule/ss_old.png": 8794,
	"./tick.png": 3180,
	"./tick_new.png": 2003,
	"./transferOwnership.png": 7807,
	"./transferOwnership_new.png": 9892,
	"./unCheckCircle.svg": 9682,
	"./wested.png": 9905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;